import { createDomain } from 'effector';
import { persist } from 'effector-storage/local';

export const SessionDomain = createDomain();

SessionDomain.onCreateStore((store) => persist({ store }));
